<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="3" v-if="!params.all">
          <v-autocomplete
            outlined
            flat
            dense
            background-color="white"
            append-icon="mdi-magnify"
            :items="subcons"
            item-text="entityName"
            item-value="id"
            v-model="params.subconId"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-menu
            v-model="menuStartDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.startDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="params.startDate"
              @input="menuStartDate = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-menu
            v-model="menuEndDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                flat
                dense
                background-color="white"
                v-model="params.endDate"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="params.endDate" @input="menuEndDate = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-select
            outlined
            flat
            dense
            background-color="white"
            :items="statuses"
            v-model="params.status"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="1" class="pt-0">
          <v-checkbox v-model="params.all" label="All Subcon"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-btn @click="search" color="primary" class="mr-2">
            <v-icon>
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn @click="excel" color="success">
            <v-icon>
              mdi-file-excel
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Invoice #</th>
              <th class="text-center">Invoice Date</th>
              <th class="text-center">Subcon Name</th>
              <th class="text-center">Due Date</th>
              <th class="text-center">Invoice Amount</th>
              <th class="text-center">PPN (in IDR)</th>
              <th class="text-center">Balance</th>
              <th class="text-center">Age fr Due</th>
              <th class="text-center">Remark</th>
              <th class="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in result.items" :key="index">
              <td>{{ item.invoiceNumber }}</td>
              <td>{{ item.invoiceDate }}</td>
              <td>{{ item.subconName }}</td>
              <td>{{ item.invoiceDueDate }}</td>
              <td>{{ formatPrice(item.invoiceAmount) }}</td>
              <td>{{ formatPrice(item.taxAmount) }}</td>
              <td>{{ formatPrice(item.balance) }}</td>
              <td>{{ item.ageForDue }}</td>
              <td>{{ item.remark }}</td>
              <td>{{ item.status }}</td>
            </tr>
            <tr>
              <td colspan="6" class="text-right">
                Total Invoice {{ params.all ? "" : result.subconName }}
              </td>
              <td>{{ formatPrice(result.total) }}</td>
            </tr>
            <tr>
              <td colspan="6" class="text-right">
                Total A/P: {{ params.all ? "" : result.subconName }}
              </td>
              <td>{{ formatPrice(result.total) }}</td>
            </tr>
            <tr>
              <td colspan="6" class="text-right">Total A/P</td>
              <td>{{ formatPrice(result.total) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import fileDownload from "js-file-download";

export default {
  name: "report-subcon-summary",
  data() {
    return {
      menuStartDate: false,
      menuEndDate: false,
      params: {
        subconId: 0,
        startDate: moment()
          .startOf("month")
          .format("yyyy-MM-DD"),
        endDate: moment().format("yyyy-MM-DD"),
        status: "all",
        all: false,
      },
      statuses: ["all", "Outstanding", "Paid"],
      subcons: [],
      result: [],
    };
  },
  methods: {
    async search() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/subconDetail", this.params)
        .then(response => {
          this.result = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getInitialData() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("subconInvoice/getSubcon")
        .then(response => {
          this.subcons = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/subconDetailExcel", this.params)
        .then(response => {
          fileDownload(
            response.data,
            `report-subcon-${this.params.startDate}-${this.params.endDate}.xlsx`
          );
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid grey;
}
</style>
